/** @jsxImportSource react */
import { Box, Button, Checkbox, IconButton, List, ListItem, ListItemText, Popover, Typography } from '@mui/material'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import { arrayMove } from '@dnd-kit/sortable'

/** Pick and order visible columns. `columns` is the current list of field keys. */
const ColumnChooser = ({ anchorEl, open, onClose, fields, columns, onChange, onReset }) => {
  const visible = fields.filter((f) => !f.hidden)
  // chosen columns first (in their order), then the rest
  const ordered = [...columns.map((k) => visible.find((f) => f.fieldKey === k)).filter(Boolean),
    ...visible.filter((f) => !columns.includes(f.fieldKey))]

  const toggle = (key) => onChange(columns.includes(key) ? columns.filter((k) => k !== key) : [...columns, key])
  const move = (key, delta) => {
    const from = columns.indexOf(key)
    const to = from + delta
    if (from < 0 || to < 0 || to >= columns.length) return
    onChange(arrayMove(columns, from, to))
  }

  return (
    <Popover open={open} anchorEl={anchorEl} onClose={onClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      slotProps={{ paper: { sx: { width: 300, maxHeight: 440 } } }}>
      <Box sx={{ display: 'flex', alignItems: 'center', px: 2, pt: 1.5 }}>
        <Typography variant="subtitle2" sx={{ flexGrow: 1 }}>Columns</Typography>
        <Button onClick={onReset}>Reset</Button>
      </Box>
      <List dense>
        {ordered.map((field) => {
          const index = columns.indexOf(field.fieldKey)
          const checked = index >= 0
          return (
            <ListItem key={field.fieldKey} disablePadding sx={{ pl: 1, pr: 1 }}
              secondaryAction={checked && (
                <Box>
                  <IconButton disabled={index === 0} onClick={() => move(field.fieldKey, -1)} aria-label={`Move ${field.label} left`}><ArrowUpwardIcon fontSize="small" /></IconButton>
                  <IconButton disabled={index === columns.length - 1} onClick={() => move(field.fieldKey, 1)} aria-label={`Move ${field.label} right`}><ArrowDownwardIcon fontSize="small" /></IconButton>
                </Box>
              )}>
              <Checkbox size="small" checked={checked} disabled={checked && columns.length === 1} onChange={() => toggle(field.fieldKey)} inputProps={{ 'aria-label': field.label }} />
              <ListItemText primary={field.label} primaryTypographyProps={{ variant: 'body2', noWrap: true }} />
            </ListItem>
          )
        })}
      </List>
    </Popover>
  )
}

export default ColumnChooser
